<template>
  <div>
    <template v-if="role == 'role1' && this.bless_path !== '/thunder/blessv1' && !hasPrivilege">
      <IncrementBox @buyPrivilege="handleBuyPrivilege" />
    </template>
    <template v-else>
      <div class="send-gift">
        <div class="content">
          <div class="title">
            礼物发上屏
            <span @click="() => this.$store.commit('SET_CONTROL_PAD', false)"></span>
          </div>
          <ul>
            <li v-for="item in gifts" :key="item.id" @click="handleClickGift(item)">
              <div><img :src="item.thumbnail || item.thumbnailUrl" /></div>
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { chttp, apis } from '@/libs/interfaces';
import { mapState } from 'vuex'
import sendPhoto from '@/mixins/send_photo'
import IncrementBox from './increment_box.vue';

const GIFT_TYPE = 21
const PNG_GIFTS = [{
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1643347626257penqian.png',
  id: '1598kyxyqywn',
  name: '钞票枪',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1643347629848penqian_icon.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1645679305853bixin.png',
  id: '8647l00iyxi7',
  name: '比心',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1649847544809bixin_icon.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1643006242093hongbao_32wei.png',
  id: '2037kysama3l',
  name: '钱途无量',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1643004769811hb_icon.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/15876054483564-生日蛋糕.png',
  id: '0',
  name: '生日蛋糕',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1587605459575生日蛋糕.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1589444100096财源滚滚_00000_iSpt.png',
  id: '2153ka6hzb5z',
  name: '财源滚滚',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1589444103184财源滚滚-小图.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1587605337825甜蜜爱情-8_00000_iSpt.png',
  id: '1',
  name: '甜蜜爱情',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1587605347946甜蜜爱情-小图.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1587604944866荧光棒_00000_iSpt.png',
  id: '3',
  name: '荧光棒',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1587604970310荧光棒.png',
}, {
  effectUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1590989905614麦霸专属-8_00000_iSpt.png',
  id: '1055kaw2baql',
  name: '麦霸专属',
  thumbnailUrl: 'https://qncweb-back1.ktvsky.com/common-web/operation_cms/1590989909213麦霸专属-小图.png',
}]
export default {
  mixins: [sendPhoto],
  computed: {
    ...mapState({
      giftPag: (state) => state.giftPag,
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      is_bind: (state) => state.bind_status,
      role: (state) => state.role,
      bless_path: (state) => state.bless_path,
      photoPath: (state) => state.photoPath,
      photo_interact_path_new: (state) => state.photo_interact_path_new,
    }),
  },
  data() {
    return {
      gifts: [],
      hasPrivilege: false,
      parentParams: {},
      entrance: '',
    }
  },
  components: {
    IncrementBox,
  },
  methods: {
    async handleClickGift(payload) {
      if (!this.is_bind) {
        return this.$store.commit('SAVE_SHOW_SCODE_BOX', true);
      }
      const params = {
        openid: this.openid,
        unionid: this.unionid,
        gift_name: payload.name,
        pic: payload.thumbnailUrl || payload.thumbnail,
        stb_pic: payload.effectUrl || payload.effect,
        count: 2,
      };
      if (payload.is_pag) {
        params.giftId = payload.id
        params.giftType = GIFT_TYPE
        params.hasBgm = payload.hasBgm
      }
      const { errcode } = await chttp.post('/vod/gift/send', params)
      if (errcode === 200) {
        this.$toast({ toastTxt: '<span style="white-space:nowrap">发送成功，请看大屏幕</span>' });
      } else {
        this.$toast('发送失败，请稍后再试')
      }
    },
    handleBuyPrivilege() {
      this.entrance = `control_vip_${this.photoPath?.entrance || ''}`
      this.buyPrivilege(() => {
        if (this.bless_path.includes('blessv1')) {
          this.$router.push('/thunder/interact');
        } else {
          this.$router.push(this.photo_interact_path_new);
        }
      })
    },
  },
  async mounted() {
    if (this.role == 'role1' && this.bless_path !== '/thunder/blessv1') {
      this.getDefault()
    }
    if (this.giftPag) {
      const { data = [] } = await chttp.get(apis.getPagGift, {
        params: { giftType: GIFT_TYPE },
      })
      this.gifts = data.slice(0, 8)
    } else {
      this.gifts = PNG_GIFTS
    }
  },
}
</script>

<style lang="scss" scoped>
.send-gift {
  width: 100vw;
  position: relative;
  &::after {
    content: "";
    width: 780px;
    height: 63px;
    background: url('https://qncweb-back1.ktvsky.com/20230223/other/9e423a23a2cac3f532fad4800b0f4128.png') no-repeat;
    background-size: 100% auto;
    position: absolute;
    bottom: -20px;
    left: -14px;
  }
}
.content {
  width: 694px;
  height: 536px;
  background-image: linear-gradient(0deg, #FFF0D0 0%, #FFFFFF 100%);
  border-radius: 60px 60px 0 0;
  margin: 0 auto;
  color: #606060;
  position: relative;
  z-index: 10;
  margin-bottom: 14px;
  .title {
    padding: 40px 0 30px;
    font-size: 40px;
    position: relative;
    text-align: center;
    span {
      position: absolute;
      right: 55px;
      top: 55px;
      display: inline-block;
      width: 31px;
      height: 26px;
      background: url(https://qncweb-back1.ktvsky.com/20230223/other/9112a858cb829deb9e40d669ab280363.png) no-repeat;
      background-size: 100%;
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 30px;
    li {
      width: 140px;
    }
    div {
      width: 120px;
      height: 120px;
      margin: 0 auto;
    }
    p {
      font-size: 28px;
      text-align: center;
      margin: 10px 0 30px;
    }
  }
}
</style>
